import { extent, scaleLinear, scaleTime } from 'd3';
import { getTickLength } from '@/components/Charts/utils/getTickLength';
import type { ChartValues, Data } from '@/types/chart';

type Props<T extends object> = {
  data: ChartValues<T>[];
  accessor: {
    getValue: (d: Data<T>) => number;
    getDate: (d: Data<T>) => Date;
  };
  innerWidth: number;
  innerHeight: number;
};

export const getScales = <T extends object>({ data, accessor, innerWidth, innerHeight }: Props<T>) => {
  const flatData = data.flatMap((d) => d.data);

  // Calculate the domain for xScale and yScale
  const xDomain = extent(flatData, accessor.getDate) as [Date, Date];
  const [minY, maxY] = extent(flatData, accessor.getValue) as [number, number];

  const yScale = scaleLinear().range([innerHeight, 0]).domain([minY, maxY]).nice();

  const tickLength = getTickLength(yScale);

  // xScales for actuall chart conent .eg. lines, plotter dots
  const xScale = scaleTime()
    .range([5, innerWidth - tickLength - 5])
    .domain(xDomain);

  // xScale for the x-Axis (should take full innerWidth)
  const xScaleAxis = scaleTime()
    .range([0, innerWidth - tickLength])
    .domain(xDomain);

  return { xScale, xScaleAxis, yScale, minY, maxY, tickLength };
};
